<template>
  <v-app>
    <appSidebar v-if="sidebar"/>
    <appHeader v-if="header"/>
    <v-main>
      <appBreadcrumbs :items="breadcrumbs" />
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="blue darken-2"
      ></v-progress-linear>
      <v-fade-transition hide-on-leave>
        <router-view/>
      </v-fade-transition>
    </v-main>
    <v-snackbar v-model="snackbar.show" :timeout="-1" :color="snackbar.color">
      {{ snackbar.message }}
    </v-snackbar>    
  </v-app>
</template>

<script>
import header from '@/components/layouts/Header';
import sidebar from '@/components/layouts/Sidebar';
// import footer from '@/components/layouts/Footer';
import breadcrumbs from '@/components/Breadcrumbs';

export default {
  components: {
    appHeader: header,
    appSidebar: sidebar,
    // appFooter: footer,
    appBreadcrumbs: breadcrumbs
  },
  computed: {
    header() { return this.$store.state.header },
    sidebar() { return this.$store.state.sidebar },
    footer() { return this.$store.state.footer },
    breadcrumbs() { return this.$route.meta.breadcrumbs },
    snackbar() { return this.$store.state.snackbar },
    loading() { return this.$store.state.loading }
  },
  watch: {
    snackbar(val) {
      if(val.show) {
        setTimeout(() => {
          this.$store.commit('CLEAR_SNACKBAR');
        }, 2000)
      }      
    }
  },
  beforeCreate() {
    this.$store.dispatch('auth/getSrruData');
  },
  created() {
    this.$store.dispatch('get_ref');
    // this.$store.dispatch('academic/getAcademicTypes');
    // this.$store.dispatch('news/get_news_types');
    // this.$store.dispatch('document/get_ref');
  }
}
</script>